  <div class="container">
    <div class="row" style="margin-bottom:-8px;">
      <div class="col-6" *ngIf="(!profileDashboardModel?.isMutualFund && profileDashboardModel?.isExternalFund && !profileDashboardModel?.isETF) || !profileDashboardModel?.isExternalFund">
        <p class="db-title rps-paragraph-two">Management style</p>
        <h4 class="db-data db-data-body rps-heading-four" data-rpa-tag-id="dashboard-managementType">{{ profileDashboardModel?.managementStyle ? profileDashboardModel.managementStyle : '&mdash;' }}</h4>
      </div>
      <div class="col-6" *ngIf="profileDashboardModel?.isMutualFund && profileDashboardModel?.isExternalFund">
        <p class="db-title rps-paragraph-two">YTD performance</p>
        <h4 class="db-data db-data-body rps-heading-four" *ngIf="dashboardModel?.prospectusExpenseRatio; else '&mdash;'">{{dashboardModel?.ytdRegular | VMFPercent}}</h4>
        <p class="caption rps-grey rps-paragraph-three db-data-body">as of {{ dashboardModel?.ytdAsOfDate | ESTPipe }}</p>
      </div>
      <div class="col-6" *ngIf="!(isExternalETF)">
        <p class="db-title rps-paragraph-two">Asset class</p>
        <h4 class="db-data db-data-body rps-heading-four" data-rpa-tag-id="assetClass">{{ profileDashboardModel?.assetClass ? profileDashboardModel.assetClass : '&mdash;' }}</h4>
      </div>
    </div>
    <!-- Internal Fund -->
    <div *ngIf="profileDashboardModel?.isInternalFund">
      <div class="row mt-2" style="margin-bottom:-24px;">
        <div class="col-6">
          <p class="db-title rps-paragraph-two">Category</p>
          <h4 class="db-data word-wrap db-data-body rps-heading-four" data-rpa-tag-id="category">{{ profileDashboardModel?.category ? profileDashboardModel.category : '&mdash;' }}</h4>
        </div>

        <div class="col-6">
          <p class="db-title rps-paragraph-two">Risk / reward scale</p>
          <div class="db-data-body">
            <risk-scale *ngIf="dashboardModel?.riskCode; else mdash" [data]="dashboardModel"></risk-scale>
            <ng-template #mdash>
              <p data-rpa-tag-id="risk">&mdash;</p>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-6">
          <p class="db-title rps-paragraph-two" *ngIf="profileDashboardModel?.isETF || profileDashboardModel?.is529 || (profileDashboardModel?.isMutualFund && !profileDashboardModel?.isFundOfFunds)">
            <a role="button" tabindex="0" class="link marketPriceLink dialog-button" (click)="setDialogInfo('Expense Ratio'); dashboardStatsComponentModal.openModalDialog($event);" href="javascript:void(0)">Expense ratio<sup>{{expenseRatioFootnote?.id}}</sup></a>
          </p>
          <p class="db-title rps-paragraph-two" *ngIf="profileDashboardModel?.isFundOfFunds && profileDashboardModel?.isMutualFund">Acquired fund fees and expenses<sup>{{expenseRatioFootnote?.id}}</sup></p>
          <h4 class="db-data rps-heading-four" *ngIf="profileDashboardModel?.expenseRatio; else mdash" data-rpa-tag-id="dashboard-expenseRatio" >{{ profileDashboardModel.expenseRatio | VMFPercent:true }}</h4>
          <ng-template #mdash>
            <h4 class="rps-heading-four" data-rpa-tag-id="dashboard-expenseRatio">&mdash;</h4>
          </ng-template>
          <p class="caption rps-grey rps-paragraph-three db-data-body" data-rpa-tag-id="dashboard-expenseRatio-asOfDate">as of {{ profileDashboardModel?.expenseRatioAsOfDate | ESTPipe }}</p>
        </div>


          <div class="col-6"  *ngIf="(profileDashboardModel?.isMutualFund || profileDashboardModel?.isETF || (profileDashboardModel?.is529 && profileDashboardModel?.isMoneyMarket))">
          <div class="cellblock">
            <p class="db-title rps-paragraph-two"><a role="button" tabindex="0" class="marketPriceLink dialog-button" (click)="setDialogInfo('SEC yield','',''); dashboardStatsComponentModal.openModalDialog($event);" href="javascript:void(0)" data-rpa-tag-id="yieldText">{{createDaysToken(dashboardModel?.yieldNote)}} SEC yield<sup *ngIf="profileDashboardModel?.isExternalFund">{{dashboardModel?.secYieldNonVgFootNote?.id}}</sup></a></p>
            <h4 class="cell-size db-data rps-heading-four" *ngIf="!dashboardModel?.yield && profileDashboardModel?.category !=='Real Estate'" data-rpa-tag-id="dashboard-secYield-pct">{{dashboardModel?.yield}}{{dashboardModel?.yield?'%':'&mdash;'}}</h4>


            <h4 class="cell-size db-data rps-heading-four" *ngIf="dashboardModel?.yield && profileDashboardModel?.category !=='Real Estate'">
              <div class="block">
                <h4 class="db-data rps-heading-four cell-size" *ngIf="staticTicker.indexOf(profileDashboardModel?.ticker)>=0">
                  <a role="button" class="secYield" tabindex="0"
                     (click)="setDialogInfo(profileDashboardModel?.longName,profileDashboardModel?.ticker,profileDashboardModel?.fundId); dashboardStatsComponentModal.openModalDialog($event);"
                     href="javascript:void(0)" data-rpa-tag-id="dashboard-secYield-pct">
                    {{dashboardModel?.yield}}{{dashboardModel?.yield?'%':'&mdash;'}}
                  </a></h4>
                <h4 class="cell-size db-data rps-heading-four" *ngIf="staticTicker.indexOf(profileDashboardModel?.ticker)<0" data-rpa-tag-id="dashboard-secYield-pct">
                  {{dashboardModel?.yield}}{{dashboardModel?.yield?'%':'&mdash;'}}

                </h4> &nbsp;
                <h4 class="cell-size yieldNote db-data rps-heading-four"  *ngFor="let yieldNote of dashboardModel?.yieldNote">
                  <h4 class="db-data rps-heading-four" *ngIf="yieldNote?.footnoteCode" > <a role="button" tabindex="0" class="link secYield" (click)="setDialogInfo(profileDashboardModel?.longName,yieldNote?.footnoteText,yieldNote?.footnoteCode); dashboardStatsComponentModal.openModalDialog($event);" href="javascript:void(0)" data-rpa-tag-id="dashboard-secYield-footnote">
                    {{yieldNote.footnoteCode}} <span class="hide-text-screenreader-only">SEC yield footnote code</span></a>
                  </h4>&nbsp;
                </h4>
              </div>
              <h4>
                <p class="caption rps-grey rps-paragraph-three db-data-body" data-rpa-tag-id="dashboard-secYield-asOfDate">as of {{ dashboardModel?.asOfDate | ESTPipe }}</p>
              </h4>
            </h4>


            <h4 style="display: block;" *ngIf="profileDashboardModel?.category ==='Real Estate' && profileDashboardModel?.isInternalFund">
              <a [attr.href]="noteUrl" class="primary-independent secYield-note">Note</a>
            </h4>
            <h4 *ngIf="profileDashboardModel?.category ==='Real Estate' && profileDashboardModel?.isExternalFund">
              <a class="mdashColor">{{dashboardModel?.yield}}{{dashboardModel?.yield?'%':'&mdash;'}}
              </a>
              <h4 class="cell-size db-data rps-heading-four" *ngIf="dashboardModel?.yield && profileDashboardModel?.category ==='Real Estate' && profileDashboardModel?.isExternalFund">
                <p class="caption rps-grey rps-paragraph-three db-data-body" data-rpa-tag-id="dashboard-secYield-asOfDate">as of {{ dashboardModel?.asOfDate | ESTPipe }}</p>
              </h4>
            </h4>
          </div>
        </div>

        <div  class="col-6" *ngIf="profileDashboardModel?.is529 && !profileDashboardModel?.isMoneyMarket && profileDashboardModel?.isInternalFund">
          <p class="db-title rps-paragraph-two">YTD returns</p>
          <h4 class="db-data rps-heading-four" *ngIf="dashboardModel?.ytdMarket && profileDashboardModel?.isETF; else elseif">{{ dashboardModel?.ytdMarket | VMFPercent }}</h4>
          <ng-template #elseif>
            <h4 class="db-data rps-heading-four" *ngIf="dashboardModel?.ytdRegular && profileDashboardModel?.is529 || profileDashboardModel?.isMutualFund; else mdash" data-rpa-tag-id="ytdPercent"> {{ dashboardModel?.ytdRegular | VMFPercent }}</h4>
          </ng-template>
          <ng-template #mdash>
            <p data-rpa-tag-id="ytdPercent">&mdash;</p>
          </ng-template>
          <p class="caption rps-grey rps-paragraph-three db-data-body" data-rpa-tag-id="ytdDate">as of {{ dashboardModel?.ytdAsOfDate | ESTPipe }}</p>
        </div>

      </div>


      <div class="row overview-top">
        <div class="col-6" *ngIf="!profileDashboardModel?.is529 && !profileDashboardModel?.isMutualFund; else isInvestment">
          <p class="db-title rps-paragraph-two">
            <a role="button" tabindex="0" class="link marketPriceLink dialog-button" (click)="setDialogInfo('Market price'); dashboardStatsComponentModal.openModalDialog($event);" href="javascript:void(0)">Market price (MP)</a>
          </p>
          <h4 class="db-data rps-heading-four" *ngIf="dashboardModel?.marketPrice; else mdash" data-rpa-tag-id="dashboard-mkt-price"> ${{ dashboardModel?.marketPrice }}</h4>
          <ng-template #mdash>
            <h4 class="rps-heading-four" data-rpa-tag-id="dashboard-mkt-price">&mdash;</h4>
          </ng-template>
          <h4 class="caption rps-grey rps-paragraph-three db-data-body rps-heading-four" *ngIf="dashboardModel?.marketPrice" data-rpa-tag-id="dashboard-mkt-price-asOfDate">as of {{ dashboardModel?.marketPriceAsOfDate | ESTPipe }}</h4>
        </div>
        <ng-template #isInvestment>
          <div class="col-6" *ngIf="!(isExternalETF)">
            <p class="db-title rps-paragraph-two">Investment minimum</p>
            <h4 class="db-data" *ngIf="profileDashboardModel?.isClosed || profileDashboardModel?.isClosedToNewInvestors; else isMinimum" data-rpa-tag-id="dashboard-minInvestment">Closed</h4>
            <ng-template #isMinimum>
              <h4 class="db-data rps-heading-four" *ngIf="dashboardModel?.minimum && dashboardModel?.minimum !== 'Not Available'; else mdash"
                  data-rpa-tag-id="dashboard-minInvestment" >{{ dashboardModel?.minimum | overflow}}</h4>
              <ng-template #mdash>
                <h4 class="rps-heading-four"  data-rpa-tag-id="dashboard-minInvestment" >&mdash;</h4>
              </ng-template>
            </ng-template>
            <p class="caption rps-grey rps-paragraph-three db-data-body" *ngIf="profileDashboardModel?.is529">per account</p>
            <p class="caption rps-grey rps-paragraph-three db-data-body" *ngIf="profileDashboardModel?.isMutualFund" data-rpa-tag-id="minInvestmentDate">as of {{ dashboardModel?.navPriceAsOfDate | ESTPipe }}</p>
          </div>
        </ng-template>

        <div class="col-6">
          <p class="db-title rps-paragraph-two">NAV price</p>


          <h4 class="db-data rps-heading-four" *ngIf="dashboardModel?.navPrice; else mdash" data-rpa-tag-id="dashboard-nav-price"> ${{ dashboardModel?.navPrice }}</h4>
          <ng-template #mdash>
            <h4 class="rps-heading-four" data-rpa-tag-id="dashboard-nav-price">&mdash;</h4>
          </ng-template>
          <p class="caption rps-grey rps-paragraph-three db-data-body" *ngIf="dashboardModel?.navPrice" data-rpa-tag-id="dashboard-nav-price-asOfDate">as of {{ dashboardModel?.navPriceAsOfDate | ESTPipe }}</p>
        </div>

        <div class="col-6" *ngIf="profileDashboardModel?.is529">
          <p class="db-title rps-paragraph-two">Unit price</p>


          <h4 class="db-data rps-heading-four" *ngIf="dashboardModel?.unitPrice; else mdash" data-rpa-tag-id="dashboard-nav-price"> ${{ dashboardModel?.unitPrice}}</h4>
          <ng-template #mdash>
            <h4 class="rps-heading-four" data-rpa-tag-id="dashboard-nav-price">&mdash;</h4>
          </ng-template>
          <p class="caption rps-grey rps-paragraph-three db-data-body" *ngIf="dashboardModel?.unitPrice" data-rpa-tag-id="dashboard-nav-price-asOfDate">as of {{ dashboardModel?.unitPriceAsOfDate | ESTPipe }}</p>
        </div>
      </div>
    </div>

    <!-- External Fund -->
    <div *ngIf="profileDashboardModel?.isExternalFund">
      <div class="row mt-2 category-bottom">
        <div class="col-6">
          <p class="db-title rps-paragraph-two">Category</p>
          <h4 class="db-data word-wrap db-data-body rps-heading-four" data-rpa-tag-id="category">{{ profileDashboardModel?.category ? profileDashboardModel.category : '&mdash;' }}</h4>
        </div>
        <div class="col-6"  *ngIf="(profileDashboardModel?.isMutualFund || (profileDashboardModel?.isETF) || (profileDashboardModel?.is529 && profileDashboardModel?.isMoneyMarket))">
          <div class="cellblock" *ngIf="!(isExternalETF)">
            <p class="db-title rps-paragraph-two"><a role="button" tabindex="0" class="marketPriceLink dialog-button" (click)="setDialogInfo('SEC yield','',''); dashboardStatsComponentModal.openModalDialog($event);" href="javascript:void(0)" data-rpa-tag-id="yieldText">{{createDaysToken(dashboardModel?.yieldNote)}} SEC yield<sup *ngIf="profileDashboardModel?.isExternalFund">{{dashboardModel?.secYieldNonVgFootNote?.id}}</sup></a></p>
            <h4 class="cell-size db-data rps-heading-four" *ngIf="!dashboardModel?.yield && profileDashboardModel?.category !=='Real Estate'" data-rpa-tag-id="dashboard-secYield-pct">{{dashboardModel?.yield}}{{dashboardModel?.yield?'%':'&mdash;'}}</h4>


            <h4 class="cell-size db-data rps-heading-four" *ngIf="dashboardModel?.yield && profileDashboardModel?.category !=='Real Estate'">
              <div class="block">
                <h4 class="db-data rps-heading-four cell-size" *ngIf="staticTicker.indexOf(profileDashboardModel?.ticker)>=0">
                  <a role="button" class="secYield"
                     (click)="setDialogInfo(profileDashboardModel?.longName,profileDashboardModel?.ticker,profileDashboardModel?.fundId); dashboardStatsComponentModal.openModalDialog($event);"
                     href="javascript:void(0)" data-rpa-tag-id="dashboard-secYield-pct">
                    {{dashboardModel?.yield}}{{dashboardModel?.yield?'%':'&mdash;'}}
                  </a></h4>
                <h4 class="cell-size db-data rps-heading-four" *ngIf="staticTicker.indexOf(profileDashboardModel?.ticker)<0" data-rpa-tag-id="dashboard-secYield-pct">
                  {{dashboardModel?.yield}}{{dashboardModel?.yield?'%':'&mdash;'}}

                </h4> &nbsp;
                <h4 class="cell-size yieldNote db-data rps-heading-four"  *ngFor="let yieldNote of dashboardModel?.yieldNote">
                  <h4 class="db-data rps-heading-four" *ngIf="yieldNote?.footnoteCode" >
                    <a role="button" tabindex="0" class="link secYield" (click)="setDialogInfo(profileDashboardModel?.longName,yieldNote?.footnoteText,yieldNote?.footnoteCode); dashboardStatsComponentModal.openModalDialog($event);" href="javascript:void(0)" data-rpa-tag-id="dashboard-secYield-footnote">
                      {{yieldNote.footnoteCode}} <span class="hide-text-screenreader-only">SEC yield footnote code</span></a>
                  </h4>&nbsp;
                </h4>
              </div>
              <h4>
                <p class="caption rps-grey rps-paragraph-three db-data-body" data-rpa-tag-id="dashboard-secYield-asOfDate">as of {{ dashboardModel?.asOfDate | ESTPipe }}</p>
              </h4>
            </h4>


            <h4 style="display: block;" *ngIf="profileDashboardModel?.category ==='Real Estate' && profileDashboardModel?.isInternalFund">
              <a [attr.href]="noteUrl" class="primary-independent secYield-note">Note</a>
            </h4>
            <h4 *ngIf="profileDashboardModel?.category ==='Real Estate' && profileDashboardModel?.isExternalFund">
              <a class="mdashColor">{{dashboardModel?.yield}}{{dashboardModel?.yield?'%':'&mdash;'}}
              </a>
              <h4 class="cell-size db-data rps-heading-four" *ngIf="dashboardModel?.yield && profileDashboardModel?.category ==='Real Estate' && profileDashboardModel?.isExternalFund">
                <p class="caption rps-grey rps-paragraph-three db-data-body" data-rpa-tag-id="dashboard-secYield-asOfDate">as of {{ dashboardModel?.asOfDate | ESTPipe }}</p>
              </h4>
            </h4>
          </div>
          <div class="col-6" *ngIf="(isExternalETF)">
            <p class="db-title rps-paragraph-two">Asset class</p>
            <h4 class="db-data db-data-body rps-heading-four" data-rpa-tag-id="assetClass">{{ profileDashboardModel?.assetClass ? profileDashboardModel.assetClass : '&mdash;' }}</h4>
          </div>
        </div>

      </div>
      <div class="row mt-4" style="margin-bottom:-16px;">
        <div class="col-6">
          <p class="db-title rps-paragraph-two">
            <a role="button" tabindex="0" class="link marketPriceLink dialog-button" (click)="setDialogInfo('Gross Expense Ratio'); dashboardStatsComponentModal.openModalDialog($event);" href="javascript:void(0)">Gross Expense ratio</a>
          </p>
          <h4 class="db-data rps-heading-four" *ngIf="profileDashboardModel?.expenseRatio; else mdash" >{{ profileDashboardModel.expenseRatio | VMFPercent:true }}</h4>
          <ng-template #mdash>
            <h4 class="rps-heading-four">&mdash;</h4>
          </ng-template>
          <p class="caption rps-grey rps-paragraph-three db-data-body">as of {{ profileDashboardModel?.expenseRatioAsOfDate | ESTPipe }}</p>
        </div>

        <div  class="col-6" *ngIf="profileDashboardModel?.is529 && !profileDashboardModel?.isMoneyMarket && profileDashboardModel?.isInternalFund">
          <p class="db-title rps-paragraph-two">YTD returns</p>
          <h4 class="db-data rps-heading-four" *ngIf="dashboardModel?.ytdMarket && profileDashboardModel?.isETF; else elseif">{{ dashboardModel?.ytdMarket | VMFPercent }}</h4>
          <ng-template #elseif>
            <h4 class="db-data rps-heading-four" *ngIf="dashboardModel?.ytdRegular && profileDashboardModel?.is529 || profileDashboardModel?.isMutualFund; else mdash" data-rpa-tag-id="ytdPercent"> {{ dashboardModel?.ytdRegular | VMFPercent }}</h4>
          </ng-template>
          <ng-template #mdash>
            <p data-rpa-tag-id="ytdPercent">&mdash;</p>
          </ng-template>
          <p class="caption rps-grey rps-paragraph-three db-data-body" data-rpa-tag-id="ytdDate">as of {{ dashboardModel?.ytdAsOfDate | ESTPipe }}</p>
        </div>
        <div class="col-6">
          <p class="db-title rps-paragraph-two">NAV price</p>


          <h4 class="db-data rps-heading-four" *ngIf="dashboardModel?.navPrice; else mdash" data-rpa-tag-id="dashboard-nav-price"> ${{ dashboardModel?.navPrice }}</h4>
          <ng-template #mdash>
            <h4 class="rps-heading-four" data-rpa-tag-id="dashboard-nav-price">&mdash;</h4>
          </ng-template>
          <p class="caption rps-grey rps-paragraph-three db-data-body" *ngIf="dashboardModel?.navPrice" data-rpa-tag-id="dashboard-nav-price-asOfDate">as of {{ dashboardModel?.navPriceAsOfDate | ESTPipe }}</p>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-6" *ngIf="!(isExternalETF)">
          <p class="db-title rps-paragraph-two">Investment minimum</p>
          <h4 class="db-data" *ngIf="profileDashboardModel?.isClosed || profileDashboardModel?.isClosedToNewInvestors; else isMinimum" data-rpa-tag-id="dashboard-minInvestment">Closed</h4>
          <ng-template #isMinimum>
            <h4 class="db-data rps-heading-four" *ngIf="dashboardModel?.minimum && dashboardModel?.minimum !== 'Not Available'; else mdash" data-rpa-tag-id="dashboard-minInvestment">{{ dashboardModel?.minimum | overflow}}</h4>
            <ng-template #mdash>
              <h4 class="rps-heading-four" data-rpa-tag-id="dashboard-minInvestment">&mdash;</h4>
            </ng-template>
          </ng-template>
          <p class="caption rps-grey rps-paragraph-three db-data-body" *ngIf="profileDashboardModel?.is529">per account</p>
          <p class="caption rps-grey rps-paragraph-three db-data-body" *ngIf="profileDashboardModel?.isMutualFund" data-rpa-tag-id="minInvestmentDate">as of {{ dashboardModel?.navPriceAsOfDate | ESTPipe }}</p>
          <p class="caption rps-grey rps-paragraph-three db-data-body investment-footer" *ngIf="profileDashboardModel?.isMutualFund" style = "margin-bottom: 48px">
            <a class="primary-reinforce see-minimums" href="javascript:void(0)" (click)="expandAndRedirect('minimums')">See minimums</a> for specific account types</p>
        </div>
      </div>
    </div>
    <c11n-modal-dialog
      modalId="dashboardStatsComponentModal"
      [headingText]="dialogTitle"
      #dashboardStatsComponentModal
    >
      <div c11n-modal-dialog-body>
        <ng-container *ngTemplateOutlet="simpleDialogContent"></ng-container>
      </div>
    </c11n-modal-dialog>
  </div>
  <ng-template #simpleDialogContent>
    <div>
      <p class="rps-paragraph-one" [innerHTML]="noteText"></p>
    </div>
  </ng-template>
